import React from 'react';
import { UserOutlined } from '@ant-design/icons';
import { Avatar, AvatarProps } from 'antd';

export const AvatarUser: React.FC<AvatarProps> = ({ size, src: logo }) => (
	<Avatar size={size ?? 'large'} icon={<UserOutlined />} src={logo} />
);
